<template lang="pug">
    app-card
      app-card-header 
        v-row.flex-nowrap(no-gutters align="baseline")
          .col-auto.sud-case-status-color.mr-2(v-bind:style="{ background: statusColor(advocatApp.appStatus) }")
          .col.ml-2(v-line-clamp="1") {{ advocatApp.appStatus.title }}
          .col-auto.mr-2(v-line-clamp="1" v-if="isBuh && advocatApp.appStatus.name=='CONFIRM'" @click.stop="toggle" style="cursor:pointer") 
             span()
               v-icon(v-if="isSelected" style="margin-top:-3px;" color="green") check_box
               v-icon(v-else style="margin-top:-3px;") check_box_outline_blank
             | В реестр
          .col-auto.text-no-wrap {{ shortDate(advocatApp.createDate) }}

      app-card-body
        app-card-headline {{ advocatApp.courtCase.shortNumber}}
        app-card-title {{ advocatApp.courtCase.essence}}
        app-card-title На оплату : 
          strong {{ advocatApp.summa }} руб.
        app-card-caption.mt-2
          | подзащитный {{ advocatApp.caseMember.persona.personaType.value==1?advocatApp.caseMember.persona.orgName:advocatApp.caseMember.persona.name}}
          br
          div(v-if="fromAdvocat")
            | судья {{ fullName(advocatApp.courtCase.judge, 'judge')}}
          div(v-else)
            | {{ advocatApp.specialist.specialistType.title }} {{ fullName(advocatApp.specialist, 'member') }}

</template>

<script>
import moment from 'moment'
moment.locale('ru');
import AppStatuses from "@/assets/data/SpecAppStatuses.json"

export default {
  props: {
    advocatApp: null,
    isBuh: {
        default:false,
        type:Boolean
    },
    fromAdvocat: {
        default:true,
        type:Boolean
    }
  },
  data () {
    return {
      isSelected: false,
    }
  },
  methods: {
    shortDate(date) {
      return moment(date).format("DD.MM.YYYY")
    },
    toggle() {
      this.isSelected ? this.isSelected = false : this.isSelected = true
      this.$emit('toggle', this.advocatApp.id)
    },
    statusColor(status) {
      if (status.color > 0 && status.color < 4) {
        return AppStatuses.colors[status.color]
      }
      return '#000'
    },
    fullName: (pers, type) => {
      if(type=="judge")
        return pers.lastName+" "+pers.firstName+" "+pers.middleName
      else if(type=="member")
        return pers.persona.personaType.value==1?pers.persona.orgName:pers.persona.name
      else 
        return pers.name
    }
  },
}
</script>

<style lang="scss" scoped>

</style>

